import styled from 'styled-components'

const StyledLink = styled('a')`
  text-decoration: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  color: inherit;
`

export default StyledLink
